import { LabelOption } from 'src/types/search/vacancy/criteria';

export type SearchVacancyCustomLabelsType = LabelOption.Internship | LabelOption.NightShifts;

export const SEARCH_VACANCY_CUSTOM_LABELS: SearchVacancyCustomLabelsType[] = [
    LabelOption.Internship,
    LabelOption.NightShifts,
];
